/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bookmarked': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M6 2a2.002 2.002 0 00-2 2v18l8-3 8 3V4a2.003 2.003 0 00-2-2H6z" _fill="currentColor" fill-rule="nonzero"/>'
  }
})
